<template>
  <component
    :is="
      isModal
        ? 'ModalComponent'
        : isBotomSheet
          ? 'BottomSheetComponent'
          : breakpoints.w > 800
            ? 'ModalComponent'
            : 'BottomSheetComponent'
    "
    ref="component"
    headerBg="#fff"
  >
    <template #header><div></div></template>
    <div class="w-full h-full md:w-[450px]">
      <slot name="header">
        <slot name="titleContainer">
          <span class="px-4 text-2xl md:text-2xl block font-medium"
            ><slot name="titleText"></slot
          ></span>
        </slot>
        <div class="py-2"></div>
        <slot name="subtitleContainer">
          <span
            class="textComponent px-4 text-sm md:text-base block title-color"
            ><slot name="subtitleText"></slot
          ></span>
        </slot>
        <slot name="banner"> </slot>
        <div class="py-4"></div>
      </slot>

      <!-- class="md:w-[700px]" -->
      <slot />
      <div
        class="px-4 py-3 flex sm:px-6 gap-3 w-full"
        v-if="!!$slots.primaryButton || !!$slots.cancelButton"
        :class="{ 'flex-row-reverse': buttonsToRight }"
      >
        <button
          class="p-4 ripple"
          v-if="!!$slots.primaryButton"
          @click="
            () => {
              onPrimaryClick()
            }
          "
          :loading="primaryButtonLoading"
        >
          <span class="title-color">
            <slot name="primaryButton"></slot>
          </span>
        </button>
        <button
          class="p-4 ripple"
          v-if="!!$slots.cancelButton"
          @click="
            () => {
              if (onCancelClick) onCancelClick()
              else hide()
            }
          "
        >
          <span class="title-color">
            <slot name="cancelButton"></slot>
          </span>
        </button>
      </div>
    </div>
  </component>
</template>

<script>
import { defineComponent } from 'vue'
import BottomSheetComponent from '../utils/BottomSheetComponent.vue'
import ModalComponent from '../utils/ModalComponent.vue'
import breakpoints from '@/utils/plugins/breackpoints-vue3.js'

export default defineComponent({
  name: 'BottomSheetModal',
  components: { BottomSheetComponent, ModalComponent },
  props: {
    isModal: false,
    isBotomSheet: false,
    onOpening: {
      type: Function,
      default: () => {
        console.log('onOpening function not set')
      },
    },
    onClosing: {
      type: Function,
      default: () => {
        console.log('onClosing function not set')
      },
    },
    onOpened: {
      type: Function,
      default: () => {
        console.log('onOpened function not set')
      },
    },
    onClosed: {
      type: Function,
      default: () => {
        console.log('onClosed function not set')
      },
    },
    onPrimaryClick: {
      type: Function,
      default: () => {
        console.log('onPrimaryClick not set')
      },
    },
    onOverlayClick: {
      type: Function,
      default: null,
    },
    onCancelClick: {
      type: Function,
      default: null,
    },
    onBackButtonClick: {
      type: Function,
      default: null,
    },
    iconLeftBg: {
      type: String,
      default: 'red',
    },
    overlayerCanDismiss: {
      type: Boolean,
      default: true,
    },
    buttonsToRight: {
      type: Boolean,
      default: true,
    },
    primaryButtonLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      reference: '',
      eventsIds: [],
      breakpoints,
    }
  },
  mounted() {},
  methods: {
    show() {
      this.$refs.component.show()
    },
    hide() {
      this.$refs.component.hide()
    },
    isVisible() {
      return this.$refs.component.isVisible()
    },
  },
  computed: {},
})
</script>
